import React, { useMemo } from 'react';
import MarkdownIt from 'markdown-it';
import DOMPurify from 'dompurify';
import '../styles/richTextDisplay.css';

const RichTextDisplay = ({ content }) => {
  const html = useMemo(() => {
    if (!content) return '';

    const md = new MarkdownIt({
      html: false,
      linkify: true,
      breaks: true
    });

    // Generate HTML from markdown
    let rawHtml = md.render(content);

    // Sanitize to prevent XSS
    const cleanHtml = DOMPurify.sanitize(rawHtml, {
      ALLOWED_TAGS: [
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
        'p', 'br', 'strong', 'em', 'u', 'code',
        'ul', 'ol', 'li', 'blockquote', 'pre',
        'a'
      ],
      ALLOWED_ATTR: ['href', 'title', 'target', 'rel']
    });

    return cleanHtml;
  }, [content]);

  return (
    <div
      className="rich-text-display"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default RichTextDisplay;
